import React from 'react';

function IntensitySlider({ value, onChange, min = 0, max = 100, step = 1, label = 'Effect Intensity' }) {
  return (
    <div className="intensity-slider">
      <div className="intensity-slider-header">
        <label className="image-upload-label" htmlFor="intensity-slider">
          {label}
        </label>
        <span className="intensity-slider-value">{value}%</span>
      </div>
      <input
        id="intensity-slider"
        type="range"
        className="custom-range intensity-range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
      />
      <div className="intensity-slider-labels">
        <span>Subtle</span>
        <span>Moderate</span>
        <span>Dramatic</span>
      </div>
    </div>
  );
}

export default IntensitySlider;
